import { AbstractPropertyPresenter } from "./AbstractPropertyPresenter";
import { IPropertyEditable } from "./IPropertyEditable";


export abstract class AbstractPropertyEditor<TSource, TValue> extends AbstractPropertyPresenter<TSource, TValue> implements IPropertyEditable<TValue> {
  constructor(source: TSource | AbstractPropertyEditor<TSource, TValue>) {
    super(source);
  }

  abstract isEditable(): boolean;

  abstract setValue(value: TValue): void;
}
